import { useCallback } from 'react';
import { HOUSE_ADS, sceneFor, type HouseAd } from '../ads/houseAds';
import { DEFAULT_AD_SCHEDULE, endpoints, type AdSchedule } from '../services/api';
import { usePolling } from './usePolling';

/**
 * Ads managed at /admin and their schedule (refreshed every 30 minutes). Falls back to
 * the built-in starters and the default schedule when none are set up or offline.
 */
export function useAds(enabled: boolean): { ads: HouseAd[]; schedule: AdSchedule } {
  const load = useCallback(
    () =>
      endpoints.ads().then((r) => ({
        schedule: r.schedule ?? DEFAULT_AD_SCHEDULE,
        ads: r.ads.map<HouseAd>((a, i) => ({
          id: a.id,
          advertiser: a.advertiser,
          headline: a.headline,
          body: a.body,
          cta: a.cta,
          url: a.url,
          image: a.image,
          scene: sceneFor(i),
        })),
      })),
    [],
  );
  const { data } = usePolling(enabled ? 'ads' : null, load, 30 * 60_000);
  return { ads: data?.ads.length ? data.ads : HOUSE_ADS, schedule: data?.schedule ?? DEFAULT_AD_SCHEDULE };
}
